export default {
  getTotalArea(state) {
    let total = 0;
    const spacesValues = Object.values(state.spaces);

    for (let i = 0; i < spacesValues.length; i += 1) {
      total += spacesValues[i].area * spacesValues[i].unit;
    }

    return total;
  },
};
